import { PROJECTS_EVENT } from 'subscriptions/events/events.enum';
import { subscriptionsFabric } from 'subscriptions/subscriptions.fabric';
import schedulePageActions from '../schedulePageActions';
import { worklogsActions, selectActiveSheetsFlat } from 'store/worklogs';
import projectTypesActions from 'store/projectTypes/projectTypesActions';
import { lcCreatedHandler, lcUpdatedHandler, applyLcDeletedToCaches } from 'store/laborClassifications';
import { stripLcFromProject } from 'helpers/laborClassification';

const handlers = {
  [PROJECTS_EVENT.updated]: (store) => (data) => {
    if (!data._id) return;
    const sheets = store.getState().schedule.sheets;

    const updatedSheets = sheets.map((el) => {
      if (el.sheet?.projectId === data._id && !el.sheet?.published) {
        return {
          ...el,
          project: { ...el.project, ...data },
          sheet: { ...el.sheet, project: { ...el.sheet.project, ...data } },
        };
      } else return el;
    });
    store.dispatch(schedulePageActions.setSheets(updatedSheets));


    const currentURL = window.location.href;
    if (!currentURL.includes('worklog') || currentURL.includes('worklog/submissions')) return;

    // Only the active tab renders these stored sheets; upsert the merged copies so the selector re-groups.
    if (currentURL.includes('worklog/active')) {
      const updated = [];
      selectActiveSheetsFlat(store.getState()).forEach((sheet) => {
        if (sheet.projectId === data._id && !sheet.published) {
          updated.push({ ...sheet, project: { ...sheet.project, ...data } });
        }
      });
      if (updated.length) store.dispatch(worklogsActions.activeSheetsUpdated(updated));
    }

    const organizationLocation = store.getState().personalProfile?.organizationLocation;
    if (organizationLocation) {
      if (!data?.assignedToLocations?.includes(organizationLocation?._id)) {
        store.dispatch(projectTypesActions.deleteProject(data?._id))
      }
    }
  },

  [PROJECTS_EVENT.lcCreated]: lcCreatedHandler,
  [PROJECTS_EVENT.lcUpdated]: lcUpdatedHandler,
  [PROJECTS_EVENT.lcDeleted]: (store) => (data) => {
    applyLcDeletedToCaches(store, data);
    const lcId = data?._id;
    if (!lcId) return;

    // Detach the LC from the embedded project copies the schedule holds, so it
    // disappears from the per-pair LC pickers (which read project alternates).
    const sheets = store.getState().schedule.sheets;
    const updatedSheets = sheets.map((el) => {
      const project = stripLcFromProject(el.project, lcId);
      const sheetProject = stripLcFromProject(el.sheet?.project, lcId);
      if (project === el.project && sheetProject === el.sheet?.project) return el;
      return {
        ...el,
        project,
        sheet: el.sheet ? { ...el.sheet, project: sheetProject } : el.sheet,
      };
    });
    if (updatedSheets.some((el, i) => el !== sheets[i])) {
      store.dispatch(schedulePageActions.setSheets(updatedSheets));
    }

    // The stored worklog sheets are only rendered on the active tab.
    if (!window.location.href.includes('worklog/active')) return;

    const updated = [];
    selectActiveSheetsFlat(store.getState()).forEach((sheet) => {
      const project = stripLcFromProject(sheet.project, lcId);
      if (project !== sheet.project) updated.push({ ...sheet, project });
    });
    if (updated.length) store.dispatch(worklogsActions.activeSheetsUpdated(updated));
  },
};

export const projectsSubscriptionMiddleware = subscriptionsFabric(
  schedulePageActions,
  PROJECTS_EVENT,
  handlers,
  { assignedToLocations: (store) => store.getState().schedule.showAllLocations }
);
